import React from 'react'

export default class VitalityIndexText extends React.Component {
  render () {
    return (
      <div className='someText' contentEditable='true'>
        <div className='someText-body'>
          <span>
            El<strong className='blue'> Índice de Vitalidad</strong> es una medición global del estado de la salud cardiovascular con base en 5 componentes que, científicamente, han mostrado que afectan
            la salud y calidad de vida de una persona. Cada componente tiene un valor máximo de 10, al igual que el índice. Su estado en los
            <strong className='blue'> cinco factores</strong> es:
          </span>
          <ul>
            { (this.props.propiedades.riesgosOcultos === 'regular')
              ? <li>
                  <strong className='blue'>Riegos ocultos:</strong>
                  <span>
                    Puede existir desgaste en su corazón y sus arterias, principalmente por fumar. Después de 6 meses sin fumar, las arterias se reponen. </span>
                </li>
              : (this.props.propiedades.riesgosOcultos === 'excelente')
              ? <li>
                  <strong className='blue'>Riegos ocultos: </strong>
                  <span>Sus riesgos están controlados.</span>
                </li>
              : ''
            }
            { (this.props.propiedades.cardiorespiratoria === 'regular')
              ? <li>
                  <strong className='blue'>Capacidad cardiorrespiratoria: </strong>
                  <span>
                    Hace poco ejercicio o su corazón está muy acelerado para su edad. Puede mejorar al hacer ejercicio físico frecuente: 30 a 60 minutos al menos 3 veces por semana. Podemos orientarlo en cómo hacerlo.
                  </span>
                </li>
              : (this.props.propiedades.cardiorespiratoria === 'excelente')
              ? <li>
                  <strong className='blue'>Capacidad cardiorespiratoria: </strong>
                  <span>Tiene buena capacidad física.</span>
                </li>
              : ''
            }
            { (this.props.propiedades.indiceSatisfaccion === 'regular')
              ? <li>
                  <strong className='blue'>Satisfacción: </strong>
                  <span>
                  Su nivel de satisfacción con lo que ha logrado en su vida hasta el momento está bajo. Esto puede mejorarlo. ¡Nuevos proyectos lo esperan!
                  </span>
                </li>
              : (this.props.propiedades.indiceSatisfaccion === 'excelente')
              ? <li>
                  <strong className='blue'>Satisfacción: </strong>
                  <span>Su nivel de satisfacción es alto.</span>
                </li>
              : ''
            }
            { (this.props.propiedades.balanceAfectivo === 'regular')
              ? <li>
                  <strong className='blue'>Balance afectivo: </strong>
                  <span>
                  Debe mejorar su balance emocional. Ya sea por preocupación o decaimiento se altera la sensación de felicidad. Busque compañía o ayuda.
                  </span>
                </li>
              : (this.props.propiedades.balanceAfectivo === 'excelente')
              ? <li>
                  <strong className='blue'>Balance afectivo: </strong>
                  <span>Tiene un buen balance emocional.</span>
                </li>
              : ''
            }
            { (this.props.propiedades.vigorFS === 'regular')
              ? <li>
                  <strong className='blue'>Vigor físico: </strong>
                  <span>
                    Los años disminuyen gradualmente el vigor. Necesita fortalecerse con más ejercicio, mejor respiración y un corazón más descansado.
                  </span>
                </li>
              : (this.props.propiedades.vigorFS === 'excelente')
              ? <li>
                  <strong className='blue'>Vigor físico: </strong>
                  <span>Tiene buen vigor general para su edad.</span>
                </li>
              : ''
            }
          </ul>
        </div>
      </div>
    )
  }
}

/* Validate Props */
VitalityIndexText.propTypes = {
  propiedades: React.PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/PrintableDashboard/vitalidadIndexText.js